import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { RuntimeConfigService } from '../config/runtime-config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private runtimeConfigService: RuntimeConfigService,
    private readonly authService: AuthService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.authService.ready()).pipe(
      switchMap(() => {
        const extraHeaders: Record<string, string> = {
          'X-App-Client': 'AECOM-RepGen',
          'X-Requested-With': 'XMLHttpRequest',
          'ocp-apim-subscription-key': this.runtimeConfigService.apimSubscriptionKey,
        };

        if (req.url.includes('file.core.windows')) {
          return next.handle(req);
        }

        if (!this.authService.hasAuthenticatedAccount) {
          return next.handle(req.clone({ setHeaders: extraHeaders }));
        }

        const scope = this.runtimeConfigService.scopes ?? '';
        const scopes = [scope];
        return from(this.authService.acquireToken(scopes)).pipe(
          switchMap((token) => {
            const setHeaders = token
              ? { ...extraHeaders, Authorization: `Bearer ${token}` }
              : extraHeaders;

            return next.handle(req.clone({ setHeaders }));
          })
        );
      })
    );
  }
}
